// extracted by mini-css-extract-plugin
export default {"body":"ModelActionDialog_body__BQqR8","removeFootprint":"ModelActionDialog_removeFootprint__VIE-l","content":"ModelActionDialog_content__5R+H2"};